/* eslint-disable react-hooks/rules-of-hooks */
import React, { memo, useEffect, useState } from "react";
import { Trans } from "@lingui/macro";
import { useMediaQuery } from "beautiful-react-hooks";
import Search from "../Search";
import { isSSR } from "../NoSSR";
import useCurrentLanguage from "../../functions/languages/useCurrentLanguage";

export const Header = memo(function Header() {
  const lang = useCurrentLanguage();
  const [isClient, setIsClient] = useState(false);

  useEffect(() => {
    setIsClient(true);
  }, []);

  const isMobile = !isSSR && useMediaQuery("(max-width: 767px)");

  if (!isClient) return null;

  return (
    <div className="TopBar__header">
      <div className="TopBar__title-wrapper">
        <div className="TopBar__title">
          <Trans>Travel by your own rules</Trans>
        </div>
        <div className="TopBar__subtitle">
          <Trans>Immersive Audio tours with included attraction tickets,</Trans>
          {!isMobile && <br />}
          {lang !== "ru" && <Trans>all-in-one for self-travel</Trans>}
        </div>
      </div>
      <Search isMainPage className="TopBar__search" theme="big" />
    </div>
  );
});
